import Nav from "olive-react-myoneui/lib/Nav";

function HorizontalNavLinkList({ className }) {
  return (
    <div className={`${className || ""} student-dashboard-wrapper px-4 py-3`}>
      <Nav
        activeKey="/"
        onSelect={(selectedKey) => alert(`selected ${selectedKey}`)}
      >
        <Nav.Item>
          <Nav.Link href="/student-dashboard" className="active">
            Dashboard
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-1" href="/">
            Courses
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-2" href="/">
            Events
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
}

export default HorizontalNavLinkList;
